export const chipTheme = {
  root: {
    borderRadius: 'var(--border-radius)',
    paddingX: 'var(--half-rem)',
    paddingY: 'var(--one-eighth-rem)',
  },
  extend: {
    agility: {
      font: {
        size: 'var(--rem)',
      },
      padding: {
        right: 'var(--half-rem)',
      },
    },
  },
  colorScheme: {
    light: {
      root: {
        background: 'var(--p-primary-100)',
        color: 'var(--text-color)',
      },
    },
  },
  css: ({ dt }: any) => `
  .p-chip {
      font-size: ${dt('chip.agility.font.size')} !important;
      padding-right: ${dt('chip.agility.padding.right')} !important;
  }
  `,
};
